import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { STORAGE_KEYS, sessionStorageService } from "service/storage";
import { getDataFromLocalstorageByKey } from "service/utils/get-data-localstorage";
import { useAuthUser } from "./authentication";

/**
 * CX-3744: resume the deferred CTA action after login.
 *
 * When a logged-out visitor clicks a "View in Imagio®" / "Check it now" link,
 * `ContentLink` stashes the intended same-origin destination in sessionStorage
 * instead of losing it behind the login dialog. Every dialog-driven login runs
 * through a forced page reload (CDC, CX-3151) or a full-page SSO redirect
 * (employees), so in-memory intent never survives — sessionStorage does. Once
 * the app comes back authenticated, this hook navigates in-app to that
 * destination (no extra reload) and clears the key so it fires exactly once.
 */
export function usePostLoginRedirect(): void {
  const navigate = useNavigate();
  const { user } = useAuthUser();

  useEffect(() => {
    const target = sessionStorageService.getItem(
      STORAGE_KEYS.POST_LOGIN_REDIRECT,
    );
    if (!target) return;

    const cdcUser = getDataFromLocalstorageByKey(STORAGE_KEYS.CDC_USER);
    if (!user && !cdcUser) return;

    sessionStorageService.removeItem(STORAGE_KEYS.POST_LOGIN_REDIRECT);
    navigate(target);
  }, [user, navigate]);
}
